// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.appManageHandler(); // 应用管理处理
  },
  appManageHandler() {
     $('.app-manage-card').on('mouseenter', function(e){
        // 阻止默认的点击行为
        e.preventDefault();
        const $this = $(this);
        // 所有卡片移除选中
        $('.app-manage-card').removeClass('app-manage-card-center selected');
        // 当前悬浮卡片添加选中
        $this.addClass('app-manage-card-center selected');
     })
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
